import { motion } from 'motion/react';
import { Clock, List } from 'lucide-react';
import { Workout } from '@/types/workout';

interface PresetWorkoutCardProps {
  workout: Workout;
  onStart: () => void;
}

export function PresetWorkoutCard({ workout, onStart }: PresetWorkoutCardProps) {
  return (
    <motion.button
      onClick={onStart}
      className="w-full text-left bg-white border border-neutral-200 rounded-xl p-6 hover:border-neutral-300 hover:shadow-sm transition-all"
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
    >
      <h3 className="text-2xl mb-2 text-neutral-900">
        {workout.name}
      </h3>
      
      <p className="text-neutral-600 mb-4">
        {workout.description}
      </p>

      <div className="flex items-center gap-4 text-neutral-500">
        <div className="flex items-center gap-1.5">
          <Clock className="w-4 h-4" />
          <span>{workout.duration_minutes} min</span>
        </div>
        <div className="flex items-center gap-1.5">
          <List className="w-4 h-4" />
          <span>{workout.exercises.length} exercises</span>
        </div>
      </div>
    </motion.button>
  );
}

